import { render, staticRenderFns } from "./UberOverview.vue?vue&type=template&id=618951b1"
import script from "./UberOverview.vue?vue&type=script&lang=js"
export * from "./UberOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports